import { AllLeaguesSchema } from '@/views/sports/AllLeagues/styles/AllLeagues.styles';

export const allLeaguesStyles: AllLeaguesSchema = {
  accordionButton: {
    color: 'white',
    sx: {
      display: 'flex',
      py: '2',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopRadius: 'md',
      border: 'none',
      bgGradient: 'linear(to-b, alpha.600, alpha.700)',
      px: '2',
      svg: {
        color: 'white',
      },
      _hover: {
        bgGradient: 'linear(to-b, alpha.700, alpha.700)',
      },
      '&[aria-expanded="false"]': {
        borderBottomRadius: 'md',
      },
    },
  },
  topLeaguesText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'semibold',
    color: 'white',
    fontSize: 'sm',
    px: 0,
  },
  accordionIcon: { color: 'gray.700' },
  accordionPanel: {
    bg: 'alpha.50',
    p: 2,
    borderBottomRadius: 'md',
  },
  accordionPanelBoxWrapper: {
    borderLeftWidth: '3px',
    borderColor: '#D69E2E',
    px: '2',
  },
  accordionPanelBoxInner: {
    mb: '2',
  },
  accordionPanelBoxInnerLink: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'semibold',
    sx: { _hover: { textDecoration: 'none' } },
  },
  marketGroupsByLetterHeadingText: {
    sx: {
      color: 'gray.700',
      fontsize: 'sm',
      py: '2',
      fontWeight: 'bold',
    },
  },
  marketGroupsByLetterAccordionItem: {
    bg: 'alpha.50',
    borderTop: 'unset',
    borderRadius: 'md',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    sx: {
      _last: {
        borderBottomRadius: 'md',
        button: {
          _last: {
            borderBottomRadius: 'md',
          },
        },
      },
      _first: {
        borderTopRadius: 'md',
        button: {
          _first: { borderTopRadius: 'md', border: 'none' },
        },
      },
    },
  },
  marketGroupsByLetterAccordionButton: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'semibold',
    sx: {
      display: 'flex',
      p: '2',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      bgGradient: 'linear(to-b, alpha.600, alpha.700)',

      _hover: {
        bgGradient: 'linear(to-b, alpha.700, alpha.700)',
      },
    },
    _last: {
      boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.20)',
      borderBottomRadius: 'initial !important',
    },
  },
  marketGroupsByLetterTitleText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'semibold',
  },
  marketGroupsByLetterCountryFlag: {
    marginRight: '10px',
    width: '1.2em',
    height: '1.2em',
  },
  marketGroupsByLetterAccordionIcon: {
    color: 'gray. 700',
  },
  marketGroupsByLetterAccordionPanel: {
    bg: 'alpha.50',
    p: '2',
    pt: 0,
    _last: {
      borderBottomRadius: 'md',
    },
  },
  marketGroupsByLetterAccordionPanelBox: {
    borderLeftWidth: '3px',
    borderColor: '#D69E2E',
    px: '2',
  },
  marketGroupsByLetterAccordionPanelLink: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'semibold',
    sx: { _hover: { textDecoration: 'none' } },
  },
  topLeaguesAccordionItem: {
    boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.20),0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    borderBottomRadius: 'md',
  },
  navWrapper: {
    pb: 3,
    mb: 3,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
  },
};
